export default "__VITE_ASSET__DoqeDoOx__"